export const Sizes = {
  Medium: 'medium',
  Small: 'small'
}
